import { Injectable, signal } from '@angular/core'

/**
 * Holds the full locale-prefixed path (e.g. `/it/blog/le-decisioni-...`) that
 * corresponds to the CURRENT page in the *other* locale.
 *
 * Most pages (home, blog list) map across locales by simply swapping the
 * `/en` <-> `/it` prefix, so they leave this `null` and the language switcher
 * falls back to that default behaviour. Pages whose path differs per locale —
 * notably blog articles, whose slug is translated — set this explicitly so the
 * switcher lands on the real translated URL instead of a 404.
 */
@Injectable({ providedIn: 'root' })
export class AlternateLocaleService {
  readonly alternatePath = signal<string | null>(null)

  set(path: string | null): void {
    this.alternatePath.set(path)
  }

  clear(): void {
    this.alternatePath.set(null)
  }
}
